import { render, staticRenderFns } from "./EditCliente.vue?vue&type=template&id=40b7da42"
import script from "./EditCliente.vue?vue&type=script&lang=js"
export * from "./EditCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports